module.exports = __webpack_public_path__ + "static/media/music_2x.4a8177d4.png";